import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/privacy-policy/page.js");
